import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export function formatToolResultAsMarkdown(summary: string): React.ReactNode {
	return (
		<div className="trace-step-body trace-markdown">
			<ReactMarkdown remarkPlugins={[remarkGfm]}>{summary}</ReactMarkdown>
		</div>
	);
}
